import React from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { useContent } from "../context/ContentContext";
import { FacilityIcon } from "../lib/facilityIcons";
import PageHero from "../components/PageHero";
import { ArrowLeft } from "lucide-react";

export default function FacilityDetail() {
  const { idx } = useParams();
  const navigate = useNavigate();
  const { content } = useContent();
  const all = (content?.facilities || []).filter((f) => !f.hidden && f.label);
  const ordered = [...all.filter((f) => f.featured), ...all.filter((f) => !f.featured)];
  const f = all.find((x) => x.id === idx) || ordered[Number(idx)];
  if (!content) return null;
  if (!f) {
    return (
      <div className="container-lux py-24 text-center" data-testid="facility-not-found">
        <p className="text-stone-500">Facility not found.</p>
        <Link to="/facilities" className="btn-primary mt-4 inline-flex">Back to facilities</Link>
      </div>
    );
  }
  const images = f.images || [];
  return (
    <div>
      <PageHero eyebrow="Facilities" title={f.label} subtitle={f.description || ""} image={images[0]} />
      <section className="container-lux py-16" data-testid="facility-detail">
        <button onClick={() => navigate("/facilities")} data-testid="facility-back" className="inline-flex items-center gap-1 text-sm text-stone-500 hover:text-rose mb-6"><ArrowLeft size={15} /> All facilities</button>
        <div className="flex items-center gap-2 text-forest"><FacilityIcon name={f.icon} size={22} className="text-rose" /><h2 className="font-serif text-3xl">{f.label}</h2></div>
        {f.description && <p className="text-stone-500 mt-3 max-w-2xl leading-relaxed">{f.description}</p>}
        {f.amenities?.length > 0 && (
          <ul className="mt-4 flex flex-wrap gap-2">
            {f.amenities.map((a, x) => <li key={x} className="text-xs bg-sand rounded-full px-3 py-1.5 text-forest">{a}</li>)}
          </ul>
        )}
        {(f.experience_id || f.gallery_category) && (
          <div className="mt-6 flex flex-wrap gap-3" data-testid="facility-ctas">
            {f.experience_id && <button onClick={() => navigate(`/experiences?exp=${f.experience_id}`)} data-testid="facility-view-experience" className="btn-primary">View the experience →</button>}
            {f.gallery_category && <button onClick={() => navigate(`/gallery?cat=${encodeURIComponent(f.gallery_category)}${f.gallery_subcategory ? `&sub=${encodeURIComponent(f.gallery_subcategory)}` : ""}&fac=${f.id}`)} data-testid="facility-view-gallery" className="btn-dark">View photo gallery →</button>}
          </div>
        )}
        {images.length > 0 && (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-8" data-testid="facility-gallery">
            {images.map((im, i) => <img key={i} src={im} alt={f.label} className="rounded-xl h-56 w-full object-cover object-center" />)}
          </div>
        )}
      </section>
    </div>
  );
}
